<template>
  <div>
    <Card class="mob-remove-table-fixed">
      <Modal
        v-model="exportModal"
        title="自定义导出">
        <Form ref="form" :model="form" :label-width="85"  :rules="ruleValidate">
          <FormItem label="选中所有字段">
            <Checkbox v-model="form.single" @on-change="ckChange">选中所有字段</Checkbox>
          </FormItem>
          <FormItem label="导出字段" prop="columns">
            <Select v-model="form.columns" placeholder="请选择导出字段" multiple>
              <Option v-for="item in tableColumnsSel" :key="item.key" :value="item.title" :label="item.title"></Option>
            </Select>
          </FormItem>
          <FormItem label="开始日期" prop="beginDate">
            <DatePicker v-model="form.beginDate" type="datetime" style="width:100%;" format="yyyy-MM-dd HH:mm:ss" :clearable="false"></DatePicker>
          </FormItem>
          <FormItem label="结束日期" prop="endDate">
            <DatePicker v-model="form.endDate"  type="datetime" style="width:100%;" format="yyyy-MM-dd HH:mm:ss" :clearable="false"></DatePicker>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="primary" @click="ok" :loading="exportLoading">确认</Button>
          <Button  @click="cancelModal" >取消</Button>
        </div>
      </Modal>

      <Modal
        v-model="exportSystemModal"
        title="系统功能维护记录">
        <Form ref="form" :model="form" :label-width="85"  :rules="ruleValidate">
          <FormItem label="开始日期" prop="beginDate">
            <DatePicker v-model="form.beginDate" type="datetime" style="width:100%;" format="yyyy-MM-dd HH:mm:ss" :clearable="false"></DatePicker>
          </FormItem>
          <FormItem label="结束日期" prop="endDate">
            <DatePicker v-model="form.endDate"  type="datetime" style="width:100%;" format="yyyy-MM-dd HH:mm:ss" :clearable="false"></DatePicker>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="primary" @click="okSystem" :loading="exportLoading">确认</Button>
          <Button  @click="cancelModal" >取消</Button>
        </div>
      </Modal>
      <search @on-result-change="onResultChange" :tableColumns="tableColumns" isDisplay='inline-block' SystemDisplay='inline-block' :isOperatorDisplay="true" ref="search"></search>

      <workSheetTable ref="workSheetTableRef" :tableColumns="tableColumns" :status="status"></workSheetTable>
    </Card>
  </div>
</template>

<script>
import search from './components/search'
import workSheetTable from './components/workSheetTable_all'
import moment from 'moment'
import { OpenApi, GetWorkSheetAllExport, GetWorkSheetSystemExport } from '../../api/logistics/worksheet'
import dayjs from 'dayjs'
import excel from '@/libs/excel'

export default {
  name: 'all-worksheet',
  components: {
    'search': search,
    'workSheetTable': workSheetTable
  },
  data () {
    return {
      status: [0, 1, 2, 3, 4],
      exportLoading: false,
      exportModal: false,
      exportSystemModal: false,
      form: {
        single: false,
        columns: [],
        beginDate: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
        endDate: new Date()
      },
      tableColumnsSel: [
        {
          title: '工单编号',
          key: 'wsid'
        },
        {
          title: '提交人',
          key: 'submitter'
        },
        {
          title: '标题',
          key: 'title'
        },
        {
          title: '工单类型',
          key: 'type'
        },
        {
          title: '工单子类',
          key: 'son_type'
        },
        {
          title: '提交时间',
          key: 'c_time'
        },
        {
          title: '受理人',
          key: 'receive_people'
        },
        {
          title: '受理时间',
          key: 'a_time'
        },
        {
          title: '处理人',
          key: 'operator'
        },
        {
          title: '处理时间',
          key: 'f_time'
        },
        {
          title: '状态',
          key: 'status'
        },
        {
          title: '审批时间',
          key: 'p_time'
        },
        {
          title: '提交人邮箱',
          key: 'submitter_email'
        },
        {
          title: '提交人企业微信用户ID',
          key: 'submitter_userid'
        },
        {
          title: '提交人上级',
          key: 'submitter_manager'
        },
        {
          title: '提交人部门',
          key: 'submitter_dep'
        },
        {
          title: '抄送人邮箱',
          key: 'cc_email'
        },
        {
          title: '截止日期',
          key: 'deadline'
        },
        {
          title: '是否延期',
          key: 'is_delay'
        },
        {
          title: '来源',
          key: 'source'
        },
        {
          title: '处理完成备注',
          key: 'process_remark'
        },
        {
          title: '归档标记',
          key: 'process_flag'
        },
        {
          title: '结果',
          key: 'result'
        },
        {
          title: '响应时间',
          key: 'response_time_count'
        },
        {
          title: '处理时间',
          key: 'solve_time_count'
        },
        {
          title: '公司',
          key: 'company'
        },
        {
          title: '问题描述',
          key: 'description'
        }
      ],
      tableColumns: [
        {
          title: '工单编号',
          align: 'center',
          width: 200,
          key: 'wsid'
        },
        {
          title: '提交人',
          align: 'center',
          width: 160,
          key: 'submitter',
          render: (h, params) => {
            if (params.row.count > 0) {
              return h('div', [
                h('span', params.row.submitter),
                h('Badge', {
                  props: {
                    count: params.row.count
                  }
                })
              ])
            }
            return h('span', params.row.submitter)
          }
        },
        {
          title: '标题',
          align: 'center',
          width: 250,
          key: 'title'
        },
        {
          title: '工单类型',
          align: 'center',
          width: 160,
          key: 'type'
        },
        {
          title: '工单子类',
          align: 'center',
          width: 160,
          key: 'son_type'
        },
        {
          title: '提交时间',
          align: 'center',
          width: 200,
          key: 'c_time',
          render: (h, params) => {
            if (params.row.c_time) {
              return h('div', moment(params.row.c_time).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '受理人',
          width: 100,
          align: 'center',
          key: 'receive_people'
        },
        {
          title: '受理时间',
          align: 'center',
          width: 160,
          key: 'a_time',
          render: (h, params) => {
            if (params.row.a_time) {
              return h('div', moment(params.row.a_time).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '处理人',
          align: 'center',
          width: 100,
          key: 'operator'
        },
        {
          title: '处理时间',
          align: 'center',
          width: 160,
          key: 'f_time',
          render: (h, params) => {
            if (params.row.f_time) {
              return h('div', moment(params.row.f_time).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '状态',
          width: 100,
          align: 'center',
          key: 'status'
        },
        {
          title: '操作',
          width: 140,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$refs.workSheetTableRef.detail(params.row.id)
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                attrs: {
                  disabled: false
                },
                on: {
                  click: () => {
                    this.open(params.row.id)
                  }
                }
              }, '打开')
            ])
          }
        }
      ],
      ruleValidate: {
        columns: [
          { required: true, message: '请选择导出字段 !', trigger: 'change', type: 'array' }
        ],
        beginDate: [
          { required: true, type: 'date', message: '请选择开始时间', trigger: 'change' }
        ],
        endDate: [
          { required: true, type: 'date', message: '请选择结束时间', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    // this.tableColumnsSel = this.tableColumns.filter((item, index) => index < 19).map(
    //   item => { return { title: item.title, key: item.key } }
    // )
  },
  updated () {
    console.log('updated')
  },
  activated () {
    this.status = [0, 1, 2, 3, 4]
    this.$refs.search.searchSubmit()
    this.$refs.workSheetTableRef.close()
  },
  methods: {
    open (id) {
      this.$Modal.confirm({
        title: '打开工单',
        content: '<p>打开后工单返回到「处理中」状态，确定要打开该工单吗？</p>',
        onOk: () => {
          OpenApi({ id: id }).then(res => {
            let result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.$refs.workSheetTableRef.init()
            } else {
              this.$Notice.error({
                title: '操作失败',
                desc: result.msg
              })
            }
          })
        }
      })
    },
    onResultChange (type) {
      if (type === 'system') {
        this.exportSystemModal = true
      } else {
        this.exportModal = true
      }
    },
    cancelModal () {
      this.form.single = false
      this.form.columns = []
      this.form.beginDate = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)
      this.form.endDate = new Date()
      this.exportModal = false
      this.exportSystemModal = false
    },
    ok () {
      // let that = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.exportLoading = true
          // let beginTime = dayjs(this.form.beginDate).format('YYYY-MM-DD HH:mm:ss')
          // let endTime = dayjs(this.form.endDate).format('YYYY-MM-DD HH:mm:ss')
          let beginTime = moment(this.form.beginDate).utc().format('YYYY-MM-DD HH:mm:ss')
          let endTime = moment(this.form.endDate).utc().format('YYYY-MM-DD HH:mm:ss')
          let params = {
            'c_time_after': beginTime,
            'c_time_before': endTime
          }
          GetWorkSheetAllExport(params).then(res => {
            this.exportLoading = false
            console.log(res.data.length)
            if (res.data.length > 0) {
              // 把返回数据的utc时间转换为当地时间
              res.data.map(item => {
                item['c_time'] = item['c_time'] ? moment(item['c_time']).format('YYYY-MM-DD HH:mm:ss') : ''
                item['a_time'] = item['a_time'] ? moment(item['a_time']).format('YYYY-MM-DD HH:mm:ss') : ''
                item['f_time'] = item['f_time'] ? moment(item['f_time']).format('YYYY-MM-DD HH:mm:ss') : ''
                item['p_time'] = item['p_time'] ? moment(item['p_time']).format('YYYY-MM-DD HH:mm:ss') : ''
              })
              const params = {
                title: this.form.columns,
                key: this.tableColumnsSel.filter((item, index) => this.form.columns.indexOf(item.title) > -1).map(m => m.key),
                data: res.data,
                autoWidth: true,
                filename: `工单导出-${dayjs(this.form.beginDate).format('YYYY-MM-DD')}.csv`
              }
              console.log(params)
              excel.export_array_to_excel(params)
            } else {
              this.$Message.info('表格数据不能为空！')
            }
          }).catch(res => {
            this.exportLoading = false
          })
        }
      })
    },

    okSystem () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.exportLoading = true
          let beginTime = moment(this.form.beginDate).utc().format('YYYY-MM-DD HH:mm:ss')
          let endTime = moment(this.form.endDate).utc().format('YYYY-MM-DD HH:mm:ss')
          let params = {
            'c_time_after': beginTime,
            'c_time_before': endTime
          }
          GetWorkSheetSystemExport(params).then(res => {
            this.exportLoading = false
            if (res.data.length > 0) {
              // 把返回数据的utc时间转换为当地时间
              res.data.map(item => {
                item['c_time'] = item['c_time'] ? moment(item['c_time']).format('YYYY-MM-DD HH:mm:ss') : ''
                item['a_time'] = item['a_time'] ? moment(item['a_time']).format('YYYY-MM-DD HH:mm:ss') : ''
                item['f_time'] = item['f_time'] ? moment(item['f_time']).format('YYYY-MM-DD HH:mm:ss') : ''
                item['p_time'] = item['p_time'] ? moment(item['p_time']).format('YYYY-MM-DD HH:mm:ss') : ''
              })
              const params = {
                title: ['工单类型', '工单子类', '具体业务功能', '维护次数'],
                key: ['type_name', 'son_type_name', 'process_flag', 'wcount'],
                data: res.data,
                autoWidth: true,
                filename: `系统功能维护记录-${dayjs(this.form.beginDate).format('YYYY-MM-DD')}.csv`
              }
              console.log(params)
              excel.export_array_to_excel(params)
              this.exportSystemModal = false
            } else {
              this.$Message.info('表格数据不能为空！')
            }
          }).catch(res => {
            this.exportLoading = false
          })
        }
      })
    },

    ckChange (val) {
      if (val) {
        this.form.columns = this.tableColumnsSel.map(item => item.title)
      } else {
        this.form.columns = []
      }
    }
  }
}
</script>
